import EmailCardContent from './EmailSmsCardContent/EmailSmsCardContent';
import GraphCardContent from './GraphCardContent/GraphCardContent';

const Overview = (props: any) => {
  const { data, isLoading } = props;
  return (
    <>
      <EmailCardContent data={data} isLoading={isLoading} />
      <GraphCardContent />
    </>
  );
};

export default Overview;
